import { ReactComponent as FilterIcon } from "@ugg/shared/assets/svg/filters-icon.svg";
import { ReactComponent as MagnifyingGlass } from "@ugg/shared/assets/svg/search-icon.svg";
import { FilterManagerWrapper } from "@ugg/shared/components/FilterManager/FilterManager";
import { MediaQuery, useResponsive } from "@outplayed/responsive";
import PatchSelect from "components/FilterManager/filters/PatchSelect";
import { ChangeEvent, useCallback } from "react";
import { useQueryString } from "hooks/general-hooks";
import { useOnFilterChange } from "components/FilterManager/FilterManager";
import { validParams } from "query_parameters/valid_parameters";
import { LaneSelect } from "components/FilterManager/filters/LaneSelect";
import LaneSplit from "components/FilterManager/filters/LaneSplit";

interface TierlistFilterProps {
  heroFilterText: string;
  setHeroFilterText: (heroFilter: string) => void;
}

const TierlistFilterManager = (props: TierlistFilterProps) => {
  const { heroFilterText, setHeroFilterText } = props;
  const onHeroFilterChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setHeroFilterText(e.target.value);
    },
    [setHeroFilterText],
  );

  const { currentBreakpoint } = useResponsive();
  const isMobile = currentBreakpoint?.includes("MOBILE");
  const queryParams: { [key: string]: any } = useQueryString();
  const onFilterChange = useOnFilterChange();

  const validPageParams = validParams["builds"] || {};

  return (
    <FilterManagerWrapper>
      <div className="filter-manager_label">
        <FilterIcon />
        <MediaQuery min="TABLET" max="DESKTOP_LARGE" renderNullOnFail>
          <span>Filters</span>
        </MediaQuery>
      </div>
      {/* <PatchSelect
        options={validPageParams.patch}
        onFilterChange={onFilterChange}
        isMobile={isMobile}
        value={queryParams["patch"] ?? "current"}
      /> */}
      <MediaQuery min="MOBILE_SMALL" max="TABLET" renderNullOnFail>
        <LaneSelect
          options={validPageParams.lane}
          onFilterChange={onFilterChange}
          isMobile={isMobile}
          value={queryParams["lane"] ?? validPageParams.lane[0].value}
        />
      </MediaQuery>
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail>
        <LaneSplit
          disableTooltip={true}
          options={validPageParams.lane}
          onFilterChange={onFilterChange}
          value={queryParams["lane"] ?? validPageParams.lane[0].value}
        />
      </MediaQuery>
      <div>
        <input className="hero-filter" placeholder="Search Hero" value={heroFilterText} onChange={onHeroFilterChange} />
        <MagnifyingGlass className="search-icon" />
      </div>
    </FilterManagerWrapper>
  );
};

export default TierlistFilterManager;
